import coreStore from "./core-store";
import Axios from 'axios'

const remoteResource = 'reconciliation/api/v1/reconciliation-matches';

const store = coreStore.queryStore(coreStore.createCoreStore('reconciliationMatch', remoteResource));

store.actions.fetchByCashEventId = ({}, cashEventId) => {
    const query = {
        parameters: {
            'cashEventDto.id': {
                operator: 'eq',
                type: 'string',
                value: cashEventId
            }
        }
    }
    const convertedQuery = encodeURIComponent(JSON.stringify(query));
    return Axios.get(`${remoteResource}?query=${convertedQuery}&size=100`)
        .then(response => response.data)
}


export default store;
